import $ from 'jquery';
export function error(message) {
  $.toast({
    displayTime: 10000,
    class: 'error',
    position: 'bottom right',
    closeIcon: 'right',
    message
  })
}

export function success(message, displayTime = 10000) {
  $.toast({
    displayTime,
    class: 'success',
    showImage: '/assets/check-circle-green.svg',
    position: 'bottom right',
    closeIcon: 'right',
    message
  })
}

export function message(data) {
  $.toast({
    displayTime: 5000,
    position: 'bottom right',
    closeIcon: 'right',
    ...data
  })
}